import clsx from 'clsx'
import React, { useEffect, useId, useRef, useState } from 'react'
import './ApplyV2Textarea.scss'

const baseClass = 'ApplyV2Textarea'

interface ApplyV2TextareaProps {
    className?: string
    placeholder?: string
    value?: string
    onChange?: (value: string) => void
    isLoading?: boolean
    isDisabled?: boolean
    isError?: boolean
    name?: string
    onBlur?: React.FocusEventHandler<HTMLDivElement>
    onFocus?: React.FocusEventHandler<HTMLDivElement>
    id?: string
    errorMessage?: string | null | boolean
    isRequired?: boolean
    isShowErrorMessage?: boolean
}

function ApplyV2Textarea({
    className = '',
    placeholder = '',
    value = '',
    onChange,
    isLoading = false,
    isDisabled = false,
    isError = false,
    name,
    onBlur,
    onFocus,
    id,
    errorMessage = null,
    isRequired = false,
    isShowErrorMessage = true,
}: ApplyV2TextareaProps) {
    const defaultId = useId()
    const divRef = useRef<HTMLDivElement>(null)
    const [isEmpty, setIsEmpty] = useState(value === '')

    const handleInput = () => {
        const text = divRef.current?.innerText || ''
        setIsEmpty(text.trim() === '')
        onChange?.(text)
    }

    useEffect(() => {
        const div = divRef?.current
        if (div && div.innerText !== value) {
            div.innerText = value || ''
        }
    }, [value])

    return (
        <div
            className={clsx(baseClass, className, {
                [`${className}`]: className,
                [`${baseClass}--loading`]: isLoading,
                [`${baseClass}--disabled`]: isDisabled,
                [`${baseClass}--empty`]: isEmpty,
                [`${baseClass}--error`]: isError,
            })}
        >
            {isEmpty && (
                <div
                    className={clsx(`${baseClass}--placeholder`, {
                        [`${className}--placeholder`]: className,
                    })}
                >
                    {placeholder}
                </div>
            )}
            <div
                className={clsx(`${baseClass}__input`, {
                    [`${className}__input`]: className,
                })}
                ref={divRef}
                contentEditable={isDisabled ? 'false' : 'plaintext-only'}
                onInput={handleInput}
                suppressContentEditableWarning
                tabIndex={0}
            ></div>
            {isLoading && <span className={`${baseClass}__loader`}></span>}
        </div>
    )
}

export default ApplyV2Textarea
